module.exports = __webpack_public_path__ + "img/page17.c2a94917.gif";